import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import Loader from "../../Components/Global/Loader";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";

import { useAuth } from "../../Context/AuthContext";
import Paginations from "../../hooks/Paginations";
import useAuthentication from "../../hooks/useAuthentication";
import useAxiosFetch from "../../hooks/useAxiosFetch";
import useSearchListPagination from "../../hooks/useSearchListPagination";
import DummyImg from "../../Public/Images/568165.png";

function WorkerDashboard({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
  

const {
  setisKeyPress,
  Count,
  setsearchKey,
  searchKey,
  setRecord,
  record,
  setPages,
  pages,
  totallength,
  paginationLoading,
  handleNextbtn,
  handlePrevbtn,
  PageShowFunc,
  SearchListApi,
  allData,
  PagesFunc,
  responseData,
} = useSearchListPagination();

  const { designation, userDetails } = useAuth();

  const [workervalue, SetWorkerValue] = useState({
    email: "",
    image: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    phone_number: "",
    worker_roles: "",
    status: "",
  });
  const {
    email,
    image,
    first_name,
    middle_name,
    last_name,
    phone_number,
    worker_roles,
    status,
  } = workervalue;
  const [TaskCount, SetCountValue] = useState();
  const [ownerValue, SetOwnerValue] = useState();

  let TenantFullName = `${first_name ? first_name : ""} ${
    middle_name ? middle_name : ""
  } ${last_name ? last_name : ""}`;

  let OwnerFullName = `${
    ownerValue?.first_name ? ownerValue?.first_name : ""
  } ${ownerValue?.middle_name ? ownerValue?.middle_name : ""} ${
    ownerValue?.last_name ? ownerValue?.last_name : ""
  }`;


  //Get worder dashboard details from database

  useEffect(() => {
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/dashboard`,
    })
      .then((response) => {
        if (response?.data) {
          SetCountValue(response?.data[0]);
          SetOwnerValue(response?.data[0]?.OwnerDetails);
          // SetCountValue(response?.data);

          // SetWorkerValue(response?.data?.WorkerData);
          // SetOwnerValue(response?.data?.userData);
        }
      })
      .catch((e) => {
        // setLoading(false);
      });
  }, [designation]);


  useEffect(() => {
    if (searchKey) {
      SearchListApi("province");
    } else {
      SearchListApi(`/task`);
    }
  }, [searchKey, record, pages]);

  useEffect(() => {
    if (userDetails) {
      SetWorkerValue(userDetails);
    }
  }, [userDetails]);

  const tableHeader=[
  
"Sl no.",
  "Building",
  "Unit",
  "Task Title",
  "Task Category",
  "Task Description" ,
  " Issue Date" ,
  "Deadline" ,

  "Priority",
  "Status",
  "Action"
  
  ]

  return (
    <DashboardLayouts>
      {(paginationLoading || allowLoading) && <Loader />}
      <div className="worker-dashboard row">
        <div className="worker-left  col-lg-6">
          <div className="row">
            <div className="worker-list1 col-md-7 col-lg-12 col-xl-7">
              <p className="heading-text">My Details</p>
              <h3 className="heading-text">
                {TenantFullName ? TenantFullName : "N/A"}
                <span>({TaskCount?.WorkerData?.PersonalDetails[0]?.worker_roles})</span>
              </h3>
              <ul className="d-flex flex-wrap mt-4">
                <li>
                  <span>Phone Number :</span>
                  <p>{phone_number}</p>
                </li>
                <li>
                  <span>Email :</span>
                  <p>{email}</p>
                </li>
              </ul>
            </div>

            <div className="worker-img-area col-md-5 col-lg-12 col-xl-5 d-flex justify-content-center justify-content-md-end justify-content-lg-center mt-4 mt-md-0 mt-lg-4">
              <div>
                <div className="worker-image">
                  <img
                    src={workervalue?.profile_image ? workervalue?.profile_image : DummyImg}
                    alt=""
                    className="profile_pic mb-lg-3 mb-md-2 mb-1"
                  />
                </div>

                <p className="text-center text-xl-end">
                  Status :
                  <span
                    style={
                      status == "1" ? { color: "green" } : { color: "red" }
                    }
                    className="text-center"
                  >
                    {status == "1" ? " Active" : " Inactive"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="worker-right col-lg-6 d-flex flex-wrap d-md-block d-md-flex align-items-center">
          <div className="card dash-unit">
            <div className="card-body">
              <p className="card-text card-title-4 dash-text">Pending Tasks</p>
              <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
                {TaskCount?.PendingTaskData ? TaskCount?.PendingTaskData : 0}
              </h2>
            </div>
          </div>

          <div className="card dash-unit">
            <div className="card-body ">
              <p className="card-text card-title-4 dash-text">
                Completed Tasks
              </p>
              <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
                {TaskCount?.CompletedTaskData
                  ? TaskCount?.CompletedTaskData
                  : 0}
              </h2>
            </div>
          </div>
          <div className="card dash-unit">
            <div className="card-body ">
              <p className="card-text card-title-4 dash-text">
               In Progress Tasks
              </p>
              <h2 className="card-title card-title-4 fw-bold dash-number mb-0">
                {TaskCount?.InProgressTaskData
                  ? TaskCount?.InProgressTaskData
                  : 0}
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="worker-dashboard worker-dashboard-2 row">
        <div className="worker-left col-lg-6">
          <div className="row">
            <div className="worker-list1 col-md-7 col-lg-12 col-xl-7">
              <p className="heading-text">Owner Details</p>
              <ul className="d-flex flex-wrap mt-4">
                <li>
                  <span> Name :</span>
                  <p>{OwnerFullName ? OwnerFullName : "N/A"}</p>
                </li>
              </ul>
              <ul className="d-flex flex-wrap">
                <li>
                  <span>Email :</span>
                  <p>{ownerValue?.email}</p>
                </li>
                <li>
                  <span>Phone Number :</span>
                

                  <p>
                    {ownerValue?.PersonalDetails[0]?.phone_number
                      ? ownerValue?.PersonalDetails[0]?.phone_number
                      : "N/A"}
                  </p>
                </li>
              </ul>
            </div>

            <div className="worker-img-area col-md-5 col-lg-12 col-xl-5 d-flex justify-content-center justify-content-md-end justify-content-lg-center mt-4 mt-md-0 mt-lg-4">
              <div>
                <div className="worker-image">
                  <img
                    src={
                      ownerValue?.PersonalDetails[0]?.profile_image
                        ? ownerValue?.PersonalDetails[0]?.profile_image
                        : DummyImg
                    }
                    alt=""
                    className="profile_pic mb-lg-3 mb-md-2 mb-1"
                  />
                </div>

               
              </div>
            </div>
          </div>
        </div>
      
      </div>

      <div className="list-data">
        <h1 className="heading-text mb-4">Task List</h1>
        {/* --- Data filter --- */}
        <div className="data-filters d-flex justify-content-between align-items-center mb-4">
          <div className="page-records d-flex align-items-center">
            <form className="number">
              <select
                className="number-box"
                value={record}
                name="record"
                onChange={(event) => {
                  setRecord(event.target.value);
                  setPages(1);
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
              </select>
            </form>
            <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
          </div>
        </div>
      </div>

      <div className="w-100 overflow-auto table-content">
        <table className="dashboard-table w-100">
          <thead className="table-heading">
            <tr>
             {tableHeader.map(hTname=>(
           
               <th key={hTname}>{hTname}</th>
          
            
             ))}
            </tr>
          </thead>

          <tbody className="t-data">
            {allData?.length >= 1 ? (
              allData?.map((items, i) => {
                return (
                  <tr key={i}>
                    <td className="text-center">
                      {" "}
                      {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                    </td>
                    <td>{items?.buildingId?.building_name}</td>
                    <td>{items?.unitId?.unit_name}</td>
                    <td> {items.task_title}</td>
                    <td> {items.task_category}</td>
                    <td> {items.task_description?.substring(0, 40)} {items.task_description?.length >41 &&  "..."}</td>
                    <td className="text-center">
                      {moment(items.createdAt).format("L")}
                    </td>
                    <td className="text-nowrap">
                      {moment(items.deadline).format("L")}
                    </td>
                    <td  style={{
                       color: `${items?.priority=="High"?"red": items?.priority=="Normal"?"blue": "green"}`
                     }}> {items.priority}</td>
                <td style={{ color: items.worker_status == "In Progress" ? "orange"  : items.worker_status == "Pending" ? "red" : "green" }}>{items.worker_status}</td>
                    <td>
                      <Link
                        to={`/worker-tasklist/${items.id}`}
                        className="d-flex justify-content-center"
                      >
                        <FaEye className=" fs-5 " color="black" />
                      </Link>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="12" className="text-center">
                  No Task List
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


                    {Count > 5 && totallength.length > 1 && (
          <Paginations
            onPageChange={PagesFunc}
            currentPage={pages}
            totalPages={totallength.length}
          />
        )}
    </DashboardLayouts>
  );
}
export default WorkerDashboard;
